import ClassicDice from '../../components/Games/ClassicDice';

const ClassicDicePage = () => {
  return <ClassicDice />;
};

export default ClassicDicePage;
